import React, { ComponentProps } from 'react';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';
import { FavoriteItem } from '../FavoritePagesTypes';
import { SortableContentList } from '../../../_lib/components/SortableContentList';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { AddExternalFavorite } from './AddExternalFavorite';
import { AddExternalFavoriteFormProps } from './AddExternalFavoriteForm';
import { DraggableFavouriteListItem } from './DraggableFavouriteListItem';
import { SonForm } from '../../../_lib/Form2';
import { AnyParameter } from '../../../_lib/Form2/types/SonForm';
import { useInvalidateRefreshableBlock } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';

type FavoritedPagesBlockEditViewProps = {
  items: FavoriteItem[];
  addExternalFavorite?: AddExternalFavoriteFormProps['form'];
  updateOrder: SonForm<AnyParameter>;
};

function EditView({ items, addExternalFavorite, updateOrder }: FavoritedPagesBlockEditViewProps) {
  const invalidateRefreshableBlock = useInvalidateRefreshableBlock();

  return (
    <>
      {addExternalFavorite && <AddExternalFavorite form={addExternalFavorite} />}
      <ScrollArea to={100} bottomOffset={10}>
        <SortableContentList items={items} form={updateOrder}>
          {item => (
            <DraggableFavouriteListItem
              id={item.id}
              key={item.id}
              link={item.content.pageLink}
              removeForm={{
                ...item.removeForm,
                onSuccess: () => {
                  invalidateRefreshableBlock(BlockType.pagemetainfo);
                },
              }}
              editForm={item.editForm}
            />
          )}
        </SortableContentList>
      </ScrollArea>
    </>
  );
}

export const FavoritedPagesBlockEditView = asFetchableView(EditView);
export type FavoritedPagesBlockEditView = ComponentProps<typeof FavoritedPagesBlockEditView>;
